import React, { useEffect, useState, useRef  } from 'react';
import { Container, Row, Alert, Modal, ListGroup, Card, CardGroup, Offcanvas, Carousel, Col, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useHistory } from 'react-router';
import Categories from './Categories';
import servicesApi from '../../../seller-apis/servicesApi';
import api from '../../../seller-apis/api';
import { categoryProductList, pendforapprovProducts, pendingProducts, searchAllPros } from '../../../seller-apis/apidataField';
import PaginationCom from '../../common/Pagination';
import Popup from '../../common/Popup';
import UpdtProPopup2 from '../../common/UpdtProPopup2'
import './SearchResultPage.css';
import '../../../assets/css/modal.css'
import genapi from '../../../seller-apis/genapi';
import SearchProCard from './SearchProCard';
import { useAlert } from 'react-alert';
import AddProductFromCataloguePopup from '../../common/AddProductFromCataloguePopup';
import PopupAddCombination from '../../common/PopupAddCombination';
import CategoryProductPopup from './CategoryProductPopup';
import { useLocation } from 'react-router-dom';


let checkedCombination = [];
var histStat = [];
let timeOutId;
let srchVal = "";
let proDetImg;
var vendorId

// For new vendors register

let isNewVend;
let NewVendTotalprcount = 0;
const SearchResultPage = (props) => {

    const alert = useAlert();

    let history = useHistory();
    const location = useLocation();

    // Size states

    const [currView, setcurrView] = useState();

    const [state, setState] = useState('category');
    const [mcList, setcList] = useState([]);
    const [scList, setscList] = useState([]);
    const [pList, setpList] = useState([]);
    const [selectedcategoryId, setselectedcategoryId] = useState();
    const [breadCrumb, setbreadCrumb] = useState([]);

    const [productRecords, setproductRecords] = useState();
    const [isPopupVisible, setisPopupVisible] = useState("none");
    const [currentProDetPrice, setcurrentProDetPrice] = useState();
    const [selectedProduct, setselectedProduct] = useState(0);
    const [selectedProductPopup, setselectedProductPopup] = useState();

    const [updtProVisibility, setupdtProVisibility] = useState(false);
    const [clickedUpdateNo, setclickedUpdateNo] = useState();
    const [selectedPage, setselectedPage] = useState(1);

    // Modal Related

    const [show, setShow] = useState(false);
    const [srchshow, setsrchshow] = useState(false);
    const [selModalProduct, setselModalProduct] = useState(1);
    const [srchModalProcurr, setsrchModalProcurr] = useState()
    const [selectedCombination, setselectedCombination] = useState([]);
    const [cbimg, setcbimg] = useState();

    // Modal list combination
    const [selectedKeys, setselectedKeys] = useState([]);
    const [checkedState, setcheckedState] = useState([]);
    const [isOldComb, setisOldComb] = useState(false);

    const handleClose = () => setShow(false);
    const handleClosesrch = () => setsrchshow(false);


    // Toast States
    const [toastquantity, settoastquantity] = useState("none");
    const [toastprice, settoastprice] = useState("none");
    const [toastweight, settoastweight] = useState("none");
    const [quantityToastMsg, setquantityToastMsg] = useState();
    const [priceToastMsg, setpriceToastMsg] = useState();
    const [weightToastMsg, setweightToastMsg] = useState();
    const [combToast, setcombToast] = useState("none");


    const [quantity, setquantity] = useState();
    const [price, setPrice] = useState();
    const [weight, setWeight] = useState();

    // Alerts related

    const [alertShow, setalertShow] = useState(false)
    const [alertMessage, setAlertMessage] = useState("");

    // FIX 1: Initialize loader as "block" to prevent "No Products Found" flash
    const [loaderProduct, setloaderProduct] = useState("block")

    const [updtPopuprel, setupdtPopuprel] = useState([]);


    // Search product

    const [searchtext, setsearchtext] = useState("");
    const [searchList, setsearchList] = useState([]);
    const [currSKU, setcurrSKU] = useState("");

    // Offcanvas for product detail
    const [srchPro, setsrchPro] = useState([]);
    const [offcanshow, setoffcanshow] = useState(false)

    // Product detail popup state
    const [showProductDetailPopup, setShowProductDetailPopup] = useState(false);
    const [currentProductDetail, setCurrentProductDetail] = useState(null);

    // Other seller's price

    const [othSellPrice, setothSellPrice] = useState()
    let categoryId;
    //SL-909
    const [searchSKU, setSearchSKU] = useState([]);
    const [searchType, setSearchType] = useState("Product Name");
    const searchDropdownRef  = useRef(null);

    // FIX 2: Ref to always hold the latest SKU list (avoids stale closure in paginate)
    const searchSKURef = useRef([]);

    useEffect(() => {
        function handleClickOutside(event) {
            // Check if click is outside the search dropdown area
            if (searchDropdownRef.current && !searchDropdownRef.current.contains(event.target)) {
                // Clicked outside the search area - hide the list
                setsearchList([]);
            }
        }

        // Add event listener
        document.addEventListener('mousedown', handleClickOutside);
        
        // Cleanup
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    useEffect(() => {
    vendorId = localStorage.getItem("vendorId")
    isNewVend = false;
    srchVal = props.match.params.srchVal
    setsearchtext(props.match.params.srchVal)
    setselectedPage(1);
    
    // Get searchType from URL query parameter
    const params = new URLSearchParams(location.search);
    const typeFromUrl = params.get('type') || "Product Name";
    setSearchType(typeFromUrl);
    
    // FIX 3: Set loader BEFORE async calls so empty state never shows
    setloaderProduct("block");

    // Handle search
    if (!srchVal || srchVal.trim() === "") {
        const data = {
            "pageNo": 1,
            "size": 15,
            "filter": {
                "SKU": { $in: [] },
                vendors: {
                    $not: {
                        $elemMatch: {
                        vendor_id: localStorage.getItem("vendorId"),
                        combination: {$exists: true, $eq: []},
                        vActive: "ACTIVE",
                        }
                    }
                }
            },
            "sortFilter": {  // 1st: most ordered in last 90 days
                "completeSellOrderCount": -1,  // 2nd: total orders all time  ← MISSING
                "productViewCount": -1,        // 3rd: most viewed            ← WRONG POSITION
                "displayActualPrice": -1        // 4th: lowest price           ← was 2nd before
            },
            "excludeField": {}
        };
        
        api.product.searchProducts(data).then((res) => {
            setloaderProduct("none");
            setpList(res.products)
            setproductRecords(res.totalRecords)
            // FIX 4: Keep ref in sync with state
            setSearchSKU([]);
            searchSKURef.current = [];
        }).catch(err => {
            setloaderProduct("none");
            console.log(err)
            setpList([])
            setproductRecords(0)
        })
    } else {
        // Use the searchType from URL
        const param = typeFromUrl === "SKU" 
            ? { "SKU-partial": srchVal }
            : { "productName-fuzzy": srchVal };
            
        const filed = { "productName": 1, "SKU": 1 };
        let paramData = {
            filter: { ...param },
            otherFilter: {},
            excludeField: { ...filed },
        }
        
        api.product
            .searchSellerProductsFilter(paramData)
            .then((res) => {
                const mSKU = res.products.map((item) => item.SKU);

                const data = {
                    "pageNo": 1,
                    "size": 15,
                    "filter": {
                        "SKU": { $in: mSKU },
                        vendors: {
                            $not: {
                                $elemMatch: {
                                vendor_id: localStorage.getItem("vendorId"),
                                combination: {$exists: true, $eq: []},
                                vActive: "ACTIVE",
                                }
                            }
                        }
                    },
                    "sortFilter": {
                           // 1st: most ordered in last 90 days
                        "completeSellOrderCount": -1,  // 2nd: total orders all time  ← MISSING
                        "productViewCount": -1,        // 3rd: most viewed            ← WRONG POSITION
                        "displayActualPrice": -1        // 4th: lowest price           ← was 2nd before
                    },

                    "excludeField": {}
                };
                
                api.product.searchProducts(data).then((res) => {
                    setloaderProduct("none");
                    setpList(res.products)
                    setproductRecords(res.totalRecords)
                    // FIX 4: Keep ref in sync with state
                    setSearchSKU(mSKU);
                    searchSKURef.current = mSKU;
                }).catch(err => {
                    setloaderProduct("none");
                })
            })
            .catch(err => {
                setloaderProduct("none");
            })
    }
    }, [location.search])


    function checkMinusInput(e) {
        if (e.code === "Minus") {
            e.preventDefault();
        }
    }

    const handleoffcanClose = () => {
        setoffcanshow(false)
    }
    // add Product
    function addProduct(index, url) {
        setcombToast("none")
        if (isNewVend) {
            if (NewVendTotalprcount <= 5) {

                var ele = document.getElementById("CombList" + index);
                let elVal = ele.value
                if (elVal === undefined || elVal === "" || elVal === null) {
                    setcombToast("block")
                }
                else {
                    if (srchPro.length > 0) {
                        if (isOldComb) {
                            let chCom = {
                                "url": url,
                                "purchase_price": elVal
                            }
                            let data = {
                                "_id": srchPro[0]._id,
                                "combination": chCom
                            }
                            api.product.addToExProduct(data).then((res) => {

                                if (res.message === "product updated" || res.message === "product added") {
                                    setShow(false)
                                    setAlertMessage("Product updated")
                                    setalertShow(true)
                                    setsrchPro([])
                                    setsearchList([])
                                    checkedCombination = [];
                                    setPrice("");
                                    getProDetail(currSKU)
                                    setTimeout(() => {
                                        setalertShow(false)
                                    }, 2500);
                                }

                            }).catch(err => console.log(err))
                        }
                        else {
                            let chCom = {
                                "url": url,
                                "purchase_price": elVal
                            }
                            let d = {
                                "_id": srchPro[0]._id,
                                "combination": chCom
                            }


                            api.product.addToExProduct(d).then((res) => {

                                if (res.message === "product updated" || res.message === "product added") {
                                    setShow(false)
                                    setAlertMessage("Product updated")
                                    setalertShow(true)
                                    checkedCombination = [];
                                    setPrice("");
                                    getProDetail(currSKU)
                                    setTimeout(() => {
                                        setalertShow(false)
                                    }, 2500);
                                }

                            }).catch(err => console.log(err))
                        }
                    }
                    else {
                        if (isOldComb) {
                            let chCom = {
                                "url": url,
                                "purchase_price": elVal
                            }
                            let data = {
                                "_id": pList[selModalProduct]._id,
                                "combination": chCom
                            }
                            api.product.addToExProduct(data).then((res) => {

                                if (res.message === "product updated" || res.message === "product added") {
                                    setShow(false)
                                    setAlertMessage("Product updated")
                                    setalertShow(true)
                                    checkedCombination = [];
                                    setPrice("");

                                }

                            }).catch(err => console.log(err))
                        }
                        else {
                            let chCom = {
                                "url": url,
                                "purchase_price": elVal
                            }
                            let d = {
                                "_id": pList[selModalProduct]._id,
                                "combination": chCom
                            }


                            api.product.addToExProduct(d).then((res) => {

                                if (res.message === "product updated" || res.message === "product added") {
                                    setShow(false)
                                    setAlertMessage("Product updated")
                                    setalertShow(true)
                                    checkedCombination = [];
                                    setPrice("");
                                }

                            }).catch(err => console.log(err))
                        }
                    }

                }
            }
            else {
                alert.info("You can add upto a max of 5 products till the time our profile gets verified")
            }

        }
        else {

            var ele = document.getElementById("CombList" + index);
            let elVal = ele.value
            if (elVal === undefined || elVal === "" || elVal === null) {
                setcombToast("block")
            }
            else {
                if (srchPro.length > 0) {
                    if (isOldComb) {
                        let chCom = {
                            "url": url,
                            "purchase_price": elVal
                        }
                        let data = {
                            "_id": srchPro[0]._id,
                            "combination": chCom
                        }
                        api.product.addToExProduct(data).then((res) => {

                            if (res.message === "product updated" || res.message === "product added") {
                                setShow(false)
                                setAlertMessage("Product updated")
                                setalertShow(true)
                                setsrchPro([])
                                setsearchList([])
                                checkedCombination = [];
                                setPrice("");
                                getProDetail(currSKU)
                                setTimeout(() => {
                                    setalertShow(false)
                                }, 2500);
                            }

                        }).catch(err => console.log(err))
                    }
                    else {
                        let chCom = {
                            "url": url,
                            "purchase_price": elVal
                        }
                        let d = {
                            "_id": srchPro[0]._id,
                            "combination": chCom
                        }


                        api.product.addToExProduct(d).then((res) => {

                            if (res.message === "product updated" || res.message === "product added") {
                                setShow(false)
                                setAlertMessage("Product updated")
                                setalertShow(true)
                                checkedCombination = [];
                                setPrice("");
                                getProDetail(currSKU)

                                setTimeout(() => {
                                    setalertShow(false)
                                }, 2500);
                            }

                        }).catch(err => console.log(err))
                    }
                }
                else {
                    if (isOldComb) {
                        let chCom = {
                            "url": url,
                            "purchase_price": elVal
                        }
                        let data = {
                            "_id": pList[selModalProduct]._id,
                            "combination": chCom
                        }
                        api.product.addToExProduct(data).then((res) => {

                            if (res.message === "product updated" || res.message === "product added") {
                                setShow(false)
                                alert.success("Product updated")
                                checkedCombination = [];
                                setPrice("");
                                let d = {
                                    "pageNo": selectedPage,
                                    "categoryId": selectedcategoryId
                                }
                            }

                        }).catch(err => console.log(err))
                    }
                    else {
                        let chCom = {
                            "url": url,
                            "purchase_price": elVal
                        }
                        let d = {
                            "_id": pList[selModalProduct]._id,
                            "combination": chCom
                        }


                        api.product.addToExProduct(d).then((res) => {

                            if (res.message === "product updated" || res.message === "product added") {
                                setShow(false)
                                alert.success("Product updated")
                                checkedCombination = [];
                                setPrice("");
                            }

                        }).catch(err => console.log(err))
                    }
                }

            }
        }

    }

    // Modal for combination products

    function addModal(id, spcl) {
        if (spcl === "srchList") {
            console.log("dk")
            setselectedCombination(srchPro[0].combination)
            setselectedKeys(srchPro[0].combination[0].value)
            console.log(id)
            setShow(false)
            setsrchshow(true)
            setsrchModalProcurr(id)
        }
        else {
            setsrchPro([])
            setisOldComb(false)
            setcombToast("none")
            checkedCombination = [];
            setcheckedState([])
            setselModalProduct(id)
            if (pList[id].vendors[0] !== null && pList[id].vendors[0].combination && pList[id].vendors[0].combination.length > 0) {
                setisOldComb(true);
            }
            if (pList[id].combination) {
                console.log(pList[id])
                if (pList[id].combination.length > 0) {
                    setselectedCombination(pList[id].combination)
                    setselectedKeys(pList[id].combination[0].value)
                }
                else {
                    setselectedCombination([])
                }
            }
            else {
                setselectedCombination([])
            }
            console.log("dhj")
            setsrchshow(false)
            setShow(true)
        }


    }

    // Popup

    function setpopupVisibility(e) {
        if (e) {
            setisPopupVisible("block")
        }
        else {
            setisPopupVisible("none")
        }
    }


    // Other sellers price

    function otherPrice(price) {
        setothSellPrice(price)
    }


    function selectProductFun(e) {

        setselectedProduct(e)
        if (pList[e].vendors && pList[e].vendors.length > 0 && pList[e].vendors[0] !== null) {
            console.log("yes")
            if (pList[e].vendors[0].combination.length > 0) {
                setcurrentProDetPrice(pList[e].vendors[0].combination[0].purchase_price)
            }
            else {
                setcurrentProDetPrice(pList[e].vendors[0].purchase_price)
            }

        }
        else {
            setcurrentProDetPrice(null)
        }
    }


    function updateRow(index, url) {

        var ele = document.getElementById("CombList" + index);
        var iseleChecked = ele.checked;
        settoastprice("none");
        if (iseleChecked) {
            if (price === undefined || price === "" || price === "0" || price === 0 || price === "") {
                ele.checked = false;
                setpriceToastMsg("Please enter a valid price");
                settoastprice("block");
            }
            else {
                let data = {
                    "url": url,
                    "purchase_price": price
                }
                checkedCombination.push(data);
                setPrice("");
                setcheckedState(checkedState.concat(data))
            }
        }
        else if (iseleChecked === false) {
            for (let i = 0; i < selectedCombination.length; i++) {
                for (let j = 0; j < checkedCombination.length; j++) {
                    if (selectedCombination[index].url === checkedCombination[j].url) {
                        checkedCombination.splice(j, 1);
                        setcheckedState(checkedCombination.filter(item => item.url !== url))
                    }
                }

            }
        }
    }


    // Product details


    function getProDetail(sku) {
        setcurrSKU(sku)
        let data = {

            "filter": {
                "SKU-Id": sku,
                vendors: {
                    $not: {
                        $elemMatch: {
                        vendor_id: localStorage.getItem("vendorId"),
                        combination: {$exists: true, $eq: []},
                        vActive: "ACTIVE",
                        }
                    }
                }
            }
        }


        api.product.searchProducts(data).then((res) => {
            console.log(res)
            setsrchPro(res.products)
            const item = res.products[0];
            const baseImg = item?.images?.find(img => img.baseImage === true)?.image || item?.images[0]?.image;
            setupdtPopuprel({
                SKU: item.SKU,
                taxClass: item.taxClass,
                pkgs: item.pkgs,
                categories: item.categories,
                shortDescription: item.shortDescription,
                description: item.description,
                product: item
            });
            setothSellPrice(item.lowestPrice)
            setoffcanshow(false)
            setcbimg(baseImg)
            setselectedProductPopup(item.productName)
            setclickedUpdateNo(0)
            setupdtProVisibility(true)

        }).catch(err => console.log(err))
    }
    // Product update option

    function checkpopupvisibility(e) {
        if (e === false) {
            setupdtProVisibility(false)
        }
        else {
            setupdtProVisibility(true)
        }
    }

    // Add product Price Popup 

    function productCheck(id, name, img, spcl, price) {
        console.log('productCheck', srchPro[0])
        if (spcl && spcl === "detail") {
            setupdtPopuprel({
                "SKU": srchPro[0].SKU,
                "taxClass": srchPro[0]?.taxClass,
                description: srchPro[0].description,
                product: srchPro[0]
            })
        }
        else {
            for (let i = 0; i < pList.length; i++) {
                if (pList[i]._id === id) {
                    console.log(pList[i])
                    setupdtPopuprel({
                        "SKU": pList[i].SKU,
                        "taxClass": pList[i].taxClass,
                        "pkgs": pList[i].pkgs,
                        "categories": pList[i].categories,
                        "shortDescription": pList[i].shortDescription,
                        "description": pList[i].description,
                        "attributeList": pList[i].attributeList,
                        "combination": pList[i].combination,
                        "vendor": pList[i]?.vendors?.[0],
                        "product": pList[i],
                        "manufacturerName": pList[i]?.manufacturerName || "",
                        "descriptionNew": pList[i].descriptionNew,
                        "specificationNew": pList[i].specificationNew,
                        "exProductReqData": pList[i].exProductReqData,
                    })
                }
            }
        }
        setothSellPrice(price)
        setoffcanshow(false)
        setcbimg(img)
        setselectedProductPopup(name)
        setclickedUpdateNo(id)
        setupdtProVisibility(true)
    }

    // Handle product card click for detail popup
    function handleProductCardClick(product) {
        setCurrentProductDetail(product);
        setShowProductDetailPopup(true);
    }

    function closeProductDetailPopup() {
        setShowProductDetailPopup(false);
        setCurrentProductDetail(null);
    }

    // Check response of product added

    function callbackResponse(msg, type) {
    if (msg === "product added" || msg === "product updated") {

        setupdtProVisibility(false);
        alert.success("Product Added Successfully");
        setsrchPro([]);
        setsearchList([]);

        // Re-run the same two-step search — DO NOT clear srchVal or searchtext
        setloaderProduct("block");

        const currentSKUList = searchSKURef.current;

        if (!srchVal || srchVal.trim() === "") {
            // No active search — reload all products
            const data = {
                "pageNo": selectedPage,
                "size": 15,
                "filter": { 
                    "SKU": { $in: [] },
                    vendors: {
                        $not: {
                            $elemMatch: {
                            vendor_id: localStorage.getItem("vendorId"),
                            combination: {$exists: true, $eq: []},
                            vActive: "ACTIVE",
                            }
                        }
                    }
                },
                "excludeField": {}
            };
            api.product.searchProducts(data).then((res) => {
                setpList(res.products);
                setproductRecords(res.totalRecords);
                setloaderProduct("none");
            }).catch(err => {
                console.log(err);
                setloaderProduct("none");
            });

        } else if (currentSKUList.length > 0) {
            // Re-fetch current page using the already-resolved SKU list (from ref)
            const data = {
                "pageNo": selectedPage,
                "size": 15,
                "filter": { "SKU": { $in: currentSKUList },
                    vendors: {
                        $not: {
                            $elemMatch: {
                            vendor_id: localStorage.getItem("vendorId"),
                            combination: {$exists: true, $eq: []},
                            vActive: "ACTIVE",
                            }
                        }
                    } 
                },
                "excludeField": {}
            };
            api.product.searchProducts(data).then((res) => {
                setpList(res.products);
                setproductRecords(res.totalRecords);
                setloaderProduct("none");
            }).catch(err => {
                console.log(err);
                setloaderProduct("none");
            });

        } else {
            // SKU list not yet resolved — redo full two-step search
            const param = searchType === "SKU"
                ? { "SKU-partial": srchVal }
                : { "productName-fuzzy": srchVal };
            const filed = { "productName": 1, "SKU": 1 };
            const paramData = { filter: { ...param }, otherFilter: {}, excludeField: { ...filed } };

            api.product.searchSellerProductsFilter(paramData).then((res) => {
                const mSKU = res.products.map((item) => item.SKU);
                setSearchSKU(mSKU);
                searchSKURef.current = mSKU;

                const data = {
                    "pageNo": selectedPage,
                    "size": 15,
                    "filter": { "SKU": { $in: mSKU },
                    vendors: {
                            $not: {
                                $elemMatch: {
                                vendor_id: localStorage.getItem("vendorId"),
                                combination: {$exists: true, $eq: []},
                                vActive: "ACTIVE",
                                }
                            }
                        } 
                    },
                    "excludeField": {}
                };
                api.product.searchProducts(data).then((res) => {
                    setpList(res.products);
                    setproductRecords(res.totalRecords);
                    setloaderProduct("none");
                }).catch(err => {
                    console.log(err);
                    setloaderProduct("none");
                });
            }).catch(err => {
                console.log(err);
                setloaderProduct("none");
            });
        }

    } else if (msg === null && type === "combination") {
        setupdtProVisibility(false);
        return;
    } else {
        setupdtProVisibility(false);
        alert.error("Product not added");
    }
}


    // FIX 5: Paginate — no DOM manipulation, use searchSKURef for always-current SKU list
    function paginate(d) {
        console.log('paginate', d)
        setupdtProVisibility(false)
        setsearchList([])
        setselectedProduct(0)
        setselectedPage(d.number)
        // Show loader via state (not DOM)
        setloaderProduct("block")

        const data = {
            "pageNo": d.number,
            "size": 15,
            "filter": {
                // FIX: Use ref instead of stale state
                "SKU": { $in: searchSKURef.current },
                vendors: {
                            $not: {
                                $elemMatch: {
                                vendor_id: localStorage.getItem("vendorId"),
                                combination: {$exists: true, $eq: []},
                                vActive: "ACTIVE",
                                }
                            }
                        } 
            },
            "sortFilter": {
                "completeSellOrderCount": -1,  // 2nd: total orders all time  ← MISSING
                "productViewCount": -1,        // 3rd: most viewed            ← WRONG POSITION
                "displayActualPrice": -1        // 4th: lowest price           ← was 2nd before
            },
            "excludeField": {}
        };

        api.product.searchProducts(data)
            .then((res) => {
                setpList(res.products)
                setState("products")
                setloaderProduct("none")
            })
            .catch(err => {
                console.log(err)
                setloaderProduct("none")
            })
    }


    function checkevent(e) {
        if (e.keyCode === 13) {
            setsearchList([])
            searchProduct()
            clearTimeout(timeOutId)
        }
    }

    function checksearchProduct(text) {
        srchVal = text;
        setsearchtext(text)
        clearTimeout(timeOutId)
        if (text === "" || text === "undefined") {
            setsearchList([])
        }
        if (text.length > 2) {
            timeOutId = setTimeout(searchProductList, 900)
            console.log(timeOutId)
        }
    }


    function searchProductList() {
        if (srchVal === "" || srchVal === undefined) {
            setsearchList([])
        }
        else {
            const param = searchType === "SKU" 
                ? { "SKU-partial": srchVal }
                : { "productName-fuzzy": srchVal };
                
            const filed = { "productName": 1, "SKU": 1 };
            let paramData = {
                filter: { ...param },
                otherFilter: {},
                excludeField: { ...filed },
            }
            
            api.product
                .searchSellerProductsFilter(paramData)
                .then((res) => {
                    setsearchList(res.products);
                })
                .catch((err) => console.log(err));
        }
    }

    function searchProduct() {
        setselectedPage(1);
        
        if (srchVal === "" || srchVal === undefined) {
            setsearchList([])
            setloaderProduct("block")

            const data = {
                "pageNo": 1,
                "size": 15,
                "filter": {
                    "SKU": { $in: [] },
                    vendors: {
                            $not: {
                                $elemMatch: {
                                vendor_id: localStorage.getItem("vendorId"),
                                combination: {$exists: true, $eq: []},
                                vActive: "ACTIVE",
                                }
                            }
                        }
                },
                 "sortFilter": {
                    "completeSellOrderCount": -1,  // 2nd: total orders all time  ← MISSING
                    "productViewCount": -1,        // 3rd: most viewed            ← WRONG POSITION
                    "displayActualPrice": -1        // 4th: lowest price           ← was 2nd before
                },
                "excludeField": {}
            };
            
            api.product.searchProducts(data).then((res) => {
                setpList(res.products)
                setproductRecords(res.totalRecords)
                // FIX 4: Keep ref in sync
                setSearchSKU([]);
                searchSKURef.current = [];
                setloaderProduct("none")
            }).catch(err => {
                console.log(err)
                setpList([])
                setproductRecords(0)
                setloaderProduct("none")
            })
            return;
        }
        else {
            setsearchList([])
            setloaderProduct("block")

            const param = searchType === "SKU" 
                ? { "SKU-partial": srchVal }
                : { "productName-fuzzy": srchVal };
                
            const filed = { "productName": 1, "SKU": 1 };
            let paramData = {
                filter: { ...param },
                otherFilter: {},
                excludeField: { ...filed },
            }
            
            api.product
                .searchSellerProductsFilter(paramData)
                .then((res) => {
                    const mSKU = res.products.map((item) => item.SKU);
                    
                    const data = {
                        "pageNo": 1,
                        "size": 15,
                        "filter": {
                            "SKU": { $in: mSKU },
                            vendors: {
                                $not: {
                                    $elemMatch: {
                                    vendor_id: localStorage.getItem("vendorId"),
                                    combination: {$exists: true, $eq: []},
                                    vActive: "ACTIVE",
                                    }
                                }
                            }
                        },
                        "sortFilter": {
                            "completeSellOrderCount": -1,  // 2nd: total orders all time  ← MISSING
                            "productViewCount": -1,        // 3rd: most viewed            ← WRONG POSITION
                            "displayActualPrice": -1        // 4th: lowest price           ← was 2nd before
                        },
                        "excludeField": {}
                    };
                    
                    api.product.searchProducts(data).then((res) => {
                        setpList(res.products)
                        setproductRecords(res.totalRecords)
                        // FIX 4: Keep ref in sync
                        setSearchSKU(mSKU);
                        searchSKURef.current = mSKU;
                        setloaderProduct("none")
                    }).catch(err => {
                        console.log(err)
                        setloaderProduct("none")
                    })
                })
                .catch((err) => {
                    console.log(err)
                    setloaderProduct("none")
                });
        }
    }



    return (
        <div className="search-result-page-container">
            {/* Search Section */}
            <div className="search-section">
                <div className="search-wrapper">
                    <select
                        className="search-type-select"
                        value={searchType}
                        onChange={(e) => {
                            const newSearchType = e.target.value;
                            setSearchType(newSearchType);
                            
                            // Clear all search-related state
                            setsearchtext("");
                            srchVal = "";
                            setsearchList([]);
                            setSearchSKU([]);
                            searchSKURef.current = [];
                            
                            // Load all products (empty search)
                            setloaderProduct("block")
                            const data = {
                                "pageNo": 1,
                                "size": 15,
                                "filter": {
                                    "SKU": { $in: [] },
                                    vendors: {
                                        $not: {
                                            $elemMatch: {
                                            vendor_id: localStorage.getItem("vendorId"),
                                            combination: {$exists: true, $eq: []},
                                            vActive: "ACTIVE",
                                            }
                                        }
                                    }
                                },
                                "sortFilter": {
                                    "completeSellOrderCount": -1,  // 2nd: total orders all time  ← MISSING
                                    "productViewCount": -1,        // 3rd: most viewed            ← WRONG POSITION
                                    "displayActualPrice": -1        // 4th: lowest price           ← was 2nd before
                                },   
                                "excludeField": {}
                            };
                            
                            api.product.searchProducts(data).then((res) => {
                                setpList(res.products)
                                setproductRecords(res.totalRecords)
                                setloaderProduct("none")
                            }).catch(err => {
                                console.log(err)
                                setpList([])
                                setproductRecords(0)
                                setloaderProduct("none")
                            })
                        }}
                    >
                        <option value="Product Name">Product Name</option>
                        <option value="SKU">SKU</option>
                    </select>
                    
                    <input 
                        type='text' 
                        placeholder={`Search by ${searchType}`}
                        className='search-input-box' 
                        value={searchtext} 
                        onKeyUp={(e) => checkevent(e)} 
                        onChange={(e) => {
                            setsearchtext(e.target.value)
                            checksearchProduct(e.target.value)
                        }}
                    />
                    <button className='search-button' onClick={() => searchProduct()}>
                        <i className="fa fa-search" aria-hidden="true"></i>
                    </button>
                </div>
                
                {searchList.length > 0 && (
                    <div className="search-results-dropdown" ref={searchDropdownRef}>
                        {searchList.map((item, index) => (
                            <div
                                key={index}
                                className="search-result-item"
                                onClick={() => getProDetail(item.SKU)}
                            >
                                <div className="search-result-text">
                                    <h4>{item.productName}</h4>
                                    <p>SKU: {item.SKU}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>

            {/* Products Section */}
            <div id="outer">
                {loaderProduct === "block" ? (
                    <div className="loading-container" id="enNewLoader">
                        <div className="spinner"></div>
                    </div>
                ) : pList.length > 0 ? (
                    <div className="products-section">
                        <div className="products-grid">
                            {pList.map((item, index) => {
                                // Multiple combinations products
                                if (item.combination && item.combination.length > 0) {
                                    let isAllcombselected = false;
                                    let combsFilled = 0;
                                    let isPendforapp = false;
                                    let pendcombs = 0;
                                    // for combination only SL-1143
                                    let expRoductPendingReq = 0;
                                    let expRoductApprovedReq = 0;
                                    let isAllCombReqPend = false;
                                    let isAllCombReqApprov = false;
                                    item.combination.map((comb, ic) => {
                                        if (item?.exProductReqData && item?.exProductReqData.length > 0) {
                                            for (let j = 0; j < item.exProductReqData.length; j++) {
                                                if (comb.url === item.exProductReqData[j]?.combination?.url) {
                                                    expRoductPendingReq = expRoductPendingReq + 1
                                                    if (item.exProductReqData[j]?.status === "APPROVED") {
                                                        expRoductApprovedReq = expRoductApprovedReq + 1
                                                    }
                                                }
                                            }
                                        }
                                    });
                                    if (expRoductPendingReq >= item.combination.length - 1 || expRoductApprovedReq >= item.combination.length - 1) {
                                        if (expRoductPendingReq === expRoductApprovedReq) {
                                            isAllCombReqApprov = true;
                                        } else {
                                            isAllCombReqPend = true;
                                        }
                                    }

                                    if (item.vendors[0] && item.vendors[0] !== null && item.vendors[0].combination) {
                                        for (let i = 0; i < item.vendors[0].combination.length; i++) {
                                            if (item.vendors[0].combination[i].purchase_price && item.vendors[0].combination[i].active && item.vendors[0].combination[i].vActive && item.vendors[0].combination[i].vActive === "ACTIVE") {
                                                combsFilled = combsFilled + 1;
                                            }
                                            if (item.vendors[0].combination[i].purchase_price) {
                                                pendcombs = pendcombs + 1
                                            }
                                        }
                                        if (combsFilled === item.combination.length - 1) {
                                            isAllcombselected = true;
                                        }
                                        if (pendcombs === item.combination.length - 1) {
                                            isPendforapp = true;
                                        }
                                    }
                                    return (
                                        <SearchProCard
                                            key={index}
                                            id={index}
                                            lead={item._id}
                                            vendors={item.vendors}
                                            selectProductIdFun={selectProductFun}
                                            images={item.images}
                                            popupVisibility={setpopupVisibility}
                                            productName={item.productName}
                                            SKU={item.SKU}
                                            price={item.lowestPrice}
                                            updtprofun={productCheck}
                                            isAllcomb={isAllcombselected}
                                            isPend={isPendforapp}
                                            otherPrice={otherPrice}
                                            onCardClick={() => handleProductCardClick(item)}
                                            manufacturerName={item.manufacturerName}
                                            isAllCombReqPend={isAllCombReqPend}
                                            isAllCombReqApprov={isAllCombReqApprov}
                                        />
                                    )
                                }
                                // No combinations 
                                else {
                                    let isAlreadyAdded = false
                                    if (item.vendors && item.vendors.length > 0) {
                                        item.vendors.map((vitem, vindex) => {
                                            if (vitem?.vendor_id === vendorId) {
                                                isAlreadyAdded = true
                                            }
                                        })
                                    }
                                    return (
                                        <SearchProCard
                                            key={index}
                                            id={index}
                                            lead={item._id}
                                            vendors={item.vendors}
                                            isalready={isAlreadyAdded}
                                            selectProductIdFun={selectProductFun}
                                            images={item.images}
                                            popupVisibility={setpopupVisibility}
                                            productName={item.productName}
                                            SKU={item.SKU}
                                            updtprofun={productCheck}
                                            price={item.lowestPrice}
                                            otherPrice={otherPrice}
                                            exProductReq={item.exProductReq}
                                            onCardClick={() => handleProductCardClick(item)}
                                            manufacturerName={item.manufacturerName}
                                        />
                                    )
                                }
                            })}
                        </div>
                        
                        {productRecords > 15 && (
                            <div className="pagination-container mt-3">
                                <PaginationCom
                                    number={productRecords}
                                    paginate={paginate}
                                    activ={selectedPage}
                                    perPage="15"
                                />
                            </div>
                        )}
                    </div>
                ) : (
                    <div className="empty-state">
                        <div className="empty-icon">
                            <i className="fa fa-inbox" aria-hidden="true"></i>
                        </div>
                        <h3 className="empty-title">No Products Found</h3>
                        <p className="empty-message">Try searching for products using the search bar above</p>
                    </div>
                )}
            </div>

            {/* Product Detail Popup */}
            {pList && pList.length > 0 && selectedProduct < pList.length && (
                <div id="popupDetail" className="overlay" style={{ "display": isPopupVisible }}>
                    <Popup
                        from="categories"
                        description={pList[selectedProduct]?.description}
                        sdescription={pList[selectedProduct]?.shortDescription}
                        descriptionNew={pList[selectedProduct]?.descriptionNew || []}
                        specificationNew={pList[selectedProduct]?.specificationNew || []}
                        name={pList[selectedProduct]?.productName}
                        price={currentProDetPrice}
                        SKU={pList[selectedProduct]?.SKU}
                        popupVisibility={setpopupVisibility}
                        images={pList[selectedProduct]?.images}
                    />
                </div>
            )}

            {/* Product Add/Edit Popup */}
            {updtProVisibility === true ? (
                updtPopuprel?.attributeList?.length > 0 ? <PopupAddCombination
                    lead={clickedUpdateNo}
                    productName={selectedProductPopup}
                    Popupvisible="block"
                    img={cbimg}
                    allImages={updtPopuprel?.product?.images}
                    detail={updtPopuprel}
                    handleDetail={setpopupVisibility}
                    Popupvisibilityfun={checkpopupvisibility}
                    from="chooseProduct"
                    callbackResFun={callbackResponse}
                    flag="TV Catalogue"
                /> :
                    <AddProductFromCataloguePopup
                        lead={clickedUpdateNo}
                        productName={selectedProductPopup}
                        Popupvisible="block"
                        img={cbimg}
                        allImages={updtPopuprel?.product?.images}
                        lowestPrice={othSellPrice}
                        detail={updtPopuprel}
                        Popupvisibilityfun={checkpopupvisibility}
                        from="chooseProduct"
                        flag="TV Catalogue"
                        callbackResFun={callbackResponse}
                    />
            ) : null}

            {/* Combination Modal */}
            {srchPro.length > 0 && selectedCombination.length > 0 && (
                <Modal show={srchshow} onHide={handleClosesrch} size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    className="addComb_modal"
                    centered>
                    <Modal.Header className='addModal_comb_header' closeButton>
                        <Modal.Title className="m-auto">Select Combination's</Modal.Title>
                    </Modal.Header>
                    <p className="toastAlert ff_Pop text-center mt-2" style={{ "display": combToast }}>
                        <i className="fa fa-exclamation" aria-hidden="true"></i> Please enter the price.
                    </p>
                    <Card className='addComb_modal_card'>
                        <ListGroup variant="flush">
                            {selectedCombination.length > 0 && selectedCombination.map((item, index) => {
                                var combPurPrice;
                                var combPurUrl;
                                var vStatus;
                                var lowestPrice = undefined
                                var isPurchasePresent = false;
                                var iscombAlready = false;
                                
                                if (srchPro[0].vendors.length > 0 && srchPro[0].vendors[0] !== null && srchPro[0].vendors[0].combination.length > 0) {
                                    srchPro[0].vendors[0].combination.map((pitem, pindex) => {
                                        if (index !== 0) {
                                            if (pitem.url === item.url) {
                                                if (!pitem.purchase_price) {
                                                    // isPurchasePresent = false;
                                                }
                                                else {
                                                    isPurchasePresent = true
                                                    combPurPrice = pitem.purchase_price
                                                    combPurUrl = pitem.url
                                                }

                                                iscombAlready = true;
                                                if (pitem.vActive) {
                                                    if (pitem.vActive === "ACTIVE" && pitem.active === true) {
                                                        vStatus = "APPROVE"
                                                    }
                                                }
                                            }
                                        }
                                    })
                                    if (!isPurchasePresent) {
                                        lowestPrice = item.lowestPrice
                                    }
                                }

                                // Handle different combination structures
                                switch (selectedKeys.length) {
                                    case 1:
                                        if (index === 0) return null;
                                        return (
                                            <ListGroup.Item key={index}>
                                                <Row className='addcomb_Modal_row'>
                                                    <div className='col-4 fs-16 f-500 mt-1'>
                                                        {selectedKeys[0]}:-{item.value[0]}
                                                    </div>
                                                    <div className='col-5 text-center'>
                                                        <form className="fs-13 mx-2">
                                                            <span className="toastAlert" style={{ "display": toastprice }}>
                                                                <i className="fa fa-exclamation" aria-hidden="true"></i>{priceToastMsg}.
                                                            </span>
                                                            <label className="d-flex mt-1">
                                                                Transfer Price(incl. {searchList[srchModalProcurr]?.taxClass}% gst) *
                                                                <input 
                                                                    type="number" 
                                                                    value={iscombAlready ? combPurPrice : undefined}
                                                                    name="number" 
                                                                    id={"CombList" + index} 
                                                                    autoComplete="off" 
                                                                    minLength="1" 
                                                                    onKeyDown={checkMinusInput} 
                                                                    required 
                                                                    onChange={(e) => setPrice(e.target.value)} 
                                                                    onWheel={(e) => e.target.blur()} 
                                                                    className="in-boxs pleft" 
                                                                />
                                                                {lowestPrice !== undefined && (
                                                                    <span className="text-warning">
                                                                        <OverlayTrigger
                                                                            key={lowestPrice}
                                                                            placement="bottom"
                                                                            overlay={
                                                                                <Tooltip id={`tooltip-${lowestPrice}`}>
                                                                                    Other seller's price: Rs.{lowestPrice}
                                                                                </Tooltip>
                                                                            }
                                                                        >
                                                                            <i className="bi bi-exclamation-triangle-fill ms-1 fs-14"></i>
                                                                        </OverlayTrigger>
                                                                    </span>
                                                                )}
                                                            </label>
                                                        </form>
                                                    </div>
                                                    <div className='col-3 f-15'>
                                                        <div className="p-Modal-Body-C col-12 fs-13 py-1">
                                                            {iscombAlready ? (
                                                                vStatus === "APPROVE" ? (
                                                                    <button className="m-auto already_added_btn col-btn-com text-white w-100 b-n p-1 up-dt">
                                                                        Already added <i className="bi bi-check"></i>
                                                                    </button>
                                                                ) : vStatus === "REJECT" ? (
                                                                    <button className="m-auto col-btn-com text-white w-100 b-n p-1 up-dt">Rejected</button>
                                                                ) : !isPurchasePresent ? (
                                                                    <button className="m-auto bg-theme text-white w-100 b-n up-dt" onClick={() => addProduct(index, item.url)}>
                                                                        Update
                                                                    </button>
                                                                ) : (
                                                                    <button className="m-auto pend_for_app_btn col-btn-com text-white w-100 b-n p-1 up-dt">
                                                                        Pending for approval <i className="bi bi-clock-history"></i>
                                                                    </button>
                                                                )
                                                            ) : (
                                                                <button className="m-auto bg-theme text-white w-100 b-n up-dt" onClick={() => addProduct(index, item.url)}>
                                                                    Update
                                                                </button>
                                                            )}
                                                        </div>
                                                    </div>
                                                </Row>
                                            </ListGroup.Item>
                                        );
                                    
                                    case 2:
                                        if (index === 0) return null;
                                        return (
                                            <ListGroup.Item key={index}>
                                                <Row className='addcomb_Modal_row'>
                                                    <div className='col-4 fs-16 f-500 mt-1'>
                                                        {selectedKeys[0]}:-{item.value[0]},{selectedKeys[1]}:-{item.value[1]}
                                                    </div>
                                                    <div className='col-5'>
                                                        <form className="fs-13 mx-2">
                                                            <span className="toastAlert" style={{ "display": toastprice }}>
                                                                <i className="fa fa-exclamation" aria-hidden="true"></i>{priceToastMsg}.
                                                            </span>
                                                            <label className="d-flex mt-1">
                                                                Transfer Price(incl. {searchList[srchModalProcurr]?.taxClass}% gst) *
                                                                <input 
                                                                    type="number"
                                                                    value={iscombAlready ? combPurPrice : undefined}
                                                                    name="number" 
                                                                    id={"CombList" + index}
                                                                    autoComplete="off"
                                                                    minLength="1"
                                                                    onKeyDown={checkMinusInput}
                                                                    required
                                                                    onChange={(e) => setPrice(e.target.value)}
                                                                    onWheel={(e) => e.target.blur()}
                                                                    className="in-boxs pleft"
                                                                />
                                                                {lowestPrice !== undefined && (
                                                                    <span className="text-warning">
                                                                        <OverlayTrigger
                                                                            key={lowestPrice}
                                                                            placement="bottom"
                                                                            overlay={
                                                                                <Tooltip id={`tooltip-${lowestPrice}`}>
                                                                                    Other seller's price: Rs.{lowestPrice}
                                                                                </Tooltip>
                                                                            }
                                                                        >
                                                                            <i className="bi bi-exclamation-triangle-fill ms-1 fs-14"></i>
                                                                        </OverlayTrigger>
                                                                    </span>
                                                                )}
                                                            </label>
                                                        </form>
                                                    </div>
                                                    <div className='col-3 f-15'>
                                                        <div className="p-Modal-Body-C col-12 fs-13 py-1">
                                                            {iscombAlready ? (
                                                                vStatus === "APPROVE" ? (
                                                                    <button className="m-auto already_added_btn col-btn-com text-white w-100 b-n p-1 up-dt">
                                                                        Already added <i className="bi bi-check"></i>
                                                                    </button>
                                                                ) : vStatus === "REJECT" ? (
                                                                    <button className="m-auto col-btn-com text-white w-100 b-n p-1 up-dt">Rejected</button>
                                                                ) : !isPurchasePresent ? (
                                                                    <button className="m-auto bg-theme text-white w-100 b-n up-dt" onClick={() => addProduct(index, item.url)}>
                                                                        Update
                                                                    </button>
                                                                ) : (
                                                                    <button className="m-auto pend_for_app_btn col-btn-com text-white w-100 b-n p-1 up-dt">
                                                                        Pending for approval <i className="bi bi-clock-history"></i>
                                                                    </button>
                                                                )
                                                            ) : (
                                                                <button className="m-auto bg-theme text-white w-100 b-n up-dt" onClick={() => addProduct(index, item.url)}>
                                                                    Update
                                                                </button>
                                                            )}
                                                        </div>
                                                    </div>
                                                </Row>
                                            </ListGroup.Item>
                                        );
                                    
                                    default:
                                        return null;
                                }
                            })}
                        </ListGroup>
                    </Card>
                </Modal>
            )}

            {/* Offcanvas for product detail */}
            {srchPro.length > 0 && (
                <Offcanvas show={offcanshow} onHide={handleoffcanClose} placement="bottom" className="h-75 w-50 m-auto" style={{ "backgroundColor": "whitesmoke" }}>
                    <Offcanvas.Header closeButton>
                        <Offcanvas.Title className="text-center">Add Product</Offcanvas.Title>
                    </Offcanvas.Header>
                    <Offcanvas.Body>
                        <Row>
                            <div className='col-5'>
                                <Carousel className='my-2 carousel'>
                                    {srchPro[0].images.map((item, index) => {
                                        let baseImg
                                        if (item.image.startsWith("products")) {
                                            baseImg = item.image;
                                            proDetImg = baseImg
                                        }
                                        else {
                                            let img = item.image.substr("41")
                                            baseImg = img;
                                            proDetImg = baseImg
                                        }
                                        return (
                                            <Carousel.Item key={index} role="button">
                                                <img
                                                    className="d-block slide-size w-100"
                                                    src={"https://s3.toolsvilla.com/" + baseImg}
                                                    alt="Product Img"
                                                />
                                            </Carousel.Item>
                                        )
                                    })}
                                </Carousel>
                            </div>
                            <div className='col-7'>
                                <p>{srchPro[0].productName}</p>
                                <p>{srchPro[0].SKU}</p>
                                <button className="pushable">
                                    <span className="shadow"></span>
                                    <span className="edge"></span>
                                    {srchPro[0].combination && srchPro[0].combination.length > 0 ? (
                                        <a className="front" onClick={() => addModal(0, "srchList")}>
                                            <i className="bi bi-plus-circle"></i> Add Product
                                        </a>
                                    ) : srchPro[0].vendors[0] === null ? (
                                        <a href="#popupAddProduct" className="front" onClick={() => productCheck(srchPro[0]._id, srchPro[0].productName, proDetImg, "detail", srchPro[0].lowestPrice)}>
                                            <i className="bi bi-plus-circle"></i> Add Product
                                        </a>
                                    ) : srchPro[0].vendors[0].vActive ? (
                                        <a href="#popupAddProduct" className="front btn-green">
                                            <i className="bi bi-check-circle-fill"></i> Already Added
                                        </a>
                                    ) : (
                                        <a href="#popupAddProduct" className="front">
                                            <i className="bi bi-check-circle-fill"></i> Pending for approval
                                        </a>
                                    )}
                                </button>
                            </div>
                        </Row>
                        <Row>
                            <Card className="mb-2 mt-2">
                                <div className="card-header cardheader f-700 fs-16 px-2">Description</div>
                                <div className="card-body cardbody" dangerouslySetInnerHTML={{ __html: srchPro[0].description }}></div>
                            </Card>
                        </Row>
                    </Offcanvas.Body>
                </Offcanvas>
            )}

            {/* Product Detail Popup */}
            {showProductDetailPopup && currentProductDetail && (
                <CategoryProductPopup
                    description={currentProductDetail.description}
                    sdescription={currentProductDetail.shortDescription}
                    descriptionNew={currentProductDetail.descriptionNew || []}
                    specificationNew={currentProductDetail.specificationNew || []}
                    name={currentProductDetail.productName}
                    price={currentProductDetail.lowestPrice}
                    SKU={currentProductDetail.SKU}
                    onClose={closeProductDetailPopup}
                    images={currentProductDetail.images}
                    pkgs={currentProductDetail.pkgs}
                    manufacturerName={currentProductDetail.manufacturerName}
                />
            )}
        </div>
    )
}

export default SearchResultPage